/* eslint-disable @nx/enforce-module-boundaries */
import {
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  output,
  signal,
  Signal,
} from '@angular/core';
import { SkeletonLoaderComponent } from '../components/skeleton-loader/skeleton-loader.component';
import { CalendarPickerComponent } from '../components/forms/calendar-picker/calendar-picker.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { OrbitFormClaimService } from '../services/orbit-form-claim.service';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'lib-orbit-claims-fault-start-date-component',
  standalone: true,
  providers: [DatePipe],
  imports: [
    CommonModule,
    CalendarPickerComponent,
    SkeletonLoaderComponent,
    FormsModule,
    ReactiveFormsModule,
    DgxComponentsIconModule,
  ],
  templateUrl: './fault-start-date.component.html',
  styleUrl: './fault-start-date.component.scss',
})
export class FaultDataComponent implements OnInit, OnDestroy {
  private _isDestroy = false;
  slotValue: string | undefined = undefined;
  selectedSlot = output<any | undefined>();
  selectedDateControl = new FormControl(false);
  datePipe = inject(DatePipe);

  claimService = inject(OrbitFormClaimService);
  selectedDate: string | undefined = `Today (${this.datePipe.transform(
    new Date(),
    'dd MMMM yyyy'
  )})`;
  dateString = signal(this.selectedDate);

  ngOnDestroy(): void {
    this._isDestroy = true;
  }

  ngOnInit(): void {
    this.selectedDateControl.valueChanges
      .pipe(takeWhile(() => !this._isDestroy))
      .subscribe((value) => {
        if (!value) {
          this.selectedDate = undefined;
          this.claimService.errorMessage.set(undefined);
          this.claimService.selectedFaultDate.set(undefined);
        }
      });
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  protected viewModel = computed(() => {
    const slotsByDate = this.getDates();
    const activeDates = slotsByDate;
    return {
      slotsByDate,
      activeDates,
      maxDate: activeDates[
        activeDates.length - 1
      ] as `${string}-${string}-${string}`,
      minDate: activeDates[0] as `${string}-${string}-${string}`,
      loading: false,
      disabled: false,
      dateString: this.dateString(),
      errorMessage: this.claimService.errorMessage(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  calculateString() {
    return this.selectedDate != null
      ? new Date(this.selectedDate).toDateString() === new Date().toDateString()
        ? `Today (${this.datePipe.transform(
            new Date(this.selectedDate),
            'dd MMMM yyyy'
          )})`
        : this.datePipe.transform(new Date(this.selectedDate), 'dd MMMM yyyy')
      : '';
  }

  getDates() {
    const minDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
    const dates = this.getDateRangeStrings(minDate, new Date());
    console.log(dates);
    return dates;
  }

  getDateRangeStrings(start: Date, end: Date): string[] {
    const dates: string[] = [];

    while (start <= end) {
      const year = start.getFullYear();
      const month = String(start.getMonth() + 1).padStart(2, '0');
      const day = String(start.getDate()).padStart(2, '0');
      dates.push(`${year}-${month}-${day}`);

      start.setDate(start.getDate() + 1);
    }

    return dates;
  }

  emitSlotValue(appointment: any | undefined = undefined): void {
    if (this.selectedDate) {
      this.dateString.set(this.calculateString());
      this.claimService.errorMessage.set(undefined);
      this.claimService.selectedFaultDate.set(this.selectedDate);
      this.selectedDateControl.setValue(true);
    }
  }
}
